module.exports = __webpack_public_path__ + "img/female-youngadult-figure.d057ddc5.svg";